export interface DividerApi {
  
}